"use strict";module.exports=require("get-intrinsic");